import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Dropdown } from 'primereact/dropdown';
import { Query } from 'react-apollo';
import { ACCOUNT_LIST } from './Query';
import { Loading } from './Loading';
import { intlShape } from './prop-types';
import { compare } from '../utils/AppUtil';

const messages = defineMessages({
  selectAccount: {
    id: 'accounts.account-selector-placeholder',
    defaultMessage: 'Select an account',
  },
});

/**
 * Displays the account selector.
 * Works only if user is authenticated.
 * The fisrt account is selected.
 */
function SideAccountSelector(props) {
  const {
    intl: { formatMessage },
  } = props;
  return (
    <Query query={ACCOUNT_LIST} variables={{ first: 999 }}>
      {({ loading, error, data }) => {
        if (error) {
          return `Error ${error.message}`;
        }

        if (loading) {
          return <Loading />;
        }

        const { viewer } = data;
        if (!viewer) {
          return <Loading />;
        }

        const { currentAccount, onAccountSelect } = props;
        const { accounts } = viewer;

        const options = accounts.edges.map(({ node }) => ({
          value: node.id,
          label: node.displayName,
        }));

        const sortedOptions = options.sort(compare);

        const placeholder = formatMessage(messages.selectAccount);
        return (
          <Dropdown
            value={currentAccount}
            options={sortedOptions}
            onChange={e => onAccountSelect(e.value)}
            filter
            filterBy="label"
            placeholder={placeholder}
            className="side-account-selector"
          />
        );
      }}
    </Query>
  );
}

SideAccountSelector.propTypes = {
  intl: intlShape.isRequired,
  currentAccount: PropTypes.string,
  onAccountSelect: PropTypes.func.isRequired,
};

SideAccountSelector.defaultProps = {
  currentAccount: null,
};

export default injectIntl(SideAccountSelector);
